import { createComponentExtension, createPlugin } from '@backstage/core-plugin-api'

import { rootRouteRef } from './routes'

export const techInsightsFactsViewPlugin = createPlugin({
  id: 'tech-insights-facts-view',
  routes: {
    root: rootRouteRef
  }
})

export const EntityFactsViewerDialog = techInsightsFactsViewPlugin.provide(
  createComponentExtension({
    name: 'TechInsightsFactsViewerDialog',
    component: {
      lazy: () =>
        import('./components/EntityFactsViewerDialog').then(
          m => m.EntityFactsViewerDialog
        )
    }
  })
)
